/** The events grid piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { EventsGridEvents } from './contract';
import { EventsGridView } from './EventsGridView';
import { useEventsGrid } from './useEventsGrid';

export function EventsGrid(props: PieceInput<EventsGridEvents>) {
  return <EventsGridView {...useEventsGrid(props)} />;
}
